import React from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";

const TypedGoogleOAuthProvider = GoogleOAuthProvider as React.FC<{
  clientId: string;
  children: React.ReactNode;
}>;

const GoogleProvider = ({ children }: { children: React.ReactNode }) => {
  const clientId = process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID || "";

  return (
    <TypedGoogleOAuthProvider clientId={clientId}>
      {children}
    </TypedGoogleOAuthProvider>
  );
};

export default GoogleProvider;
